import { BaseMany, BaseOne } from '@cnx-saas/common';
import { Packaging } from './Packaging';

/**
 * The pallet type that goods are placed on. The pallet type is used for LDM calculations.
 * https://en.wikipedia.org/wiki/Pallet#European_pallets
 */
// TODO: add standard pallets as default seed for article units in DB, then remove this enum
export enum ArticleLogisticalUnit {
  /** EUR-1 pallet (800mm×1200mm) */
  PALLET_EUR1 = 'PALLET_EUR1',
  /** EUR-2 pallet (1200mm×1000mm) */
  PALLET_EUR2 = 'PALLET_EUR2',
  /** EUR-6 pallet (800mm×600mm) */
  PALLET_EUR6 = 'PALLET_EUR6',
}

export type ArticleInput = ArticleBase & {
  packagingOptions: ArticlePackagingInput[];
};

export type ArticlePackagingBase = {
  articlesPerPackage: number;
};

export type ArticlePackagingInput = ArticlePackagingBase & {
  packagingCode: string;
  maxStackSize?: number;
};

export type ArticlePackaging = ArticlePackagingBase & {
  packaging: Packaging;
  maxStackSize: number;
};

export type ArticlePackagingOrderInput = ArticlePackagingBase & {
  packaging: Packaging;
  packagingCode: string;
  maxStackSize?: number;
};

export type ArticleBase = {
  externalReference?: string;
  name: string;
  weightInKgPerUnit: number;
};

export type ArticleEmbedded = ArticleBase & {
  id: string;
  packagingOptions: ArticlePackaging[];
};

export type Article = BaseOne &
  ArticleEmbedded & {
    tenantId: string;
  };

export type Articles = BaseMany<Article>;

export function getPackagingCodes(articleInput: ArticleInput): string[] {
  return articleInput.packagingOptions.map(
    (packaging) => packaging.packagingCode,
  );
}
